import { useEffect, useState } from "react";

// Atrasa o valor que dirige filtro/abertura da árvore (e a carga preguiçosa de
// cartões), evitando uma rajada de fetches por tecla. O input em si permanece imediato.
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
